import { z } from 'zod';
import { dateFilterSchema } from '../../../../../helpers/dateFilterSchema';

export const ProgressFilterSchema = dateFilterSchema.extend({
	operation: z
		.object({
			value: z.string(),
			label: z.string().optional(),
		})
		.nullable()
		.optional()
		.transform((value) => value?.value),
	orderTypeId: z
		.object({
			value: z.string(),
			label: z.string().optional(),
		})
		.nullable()
		.optional()
		.transform((value) => value?.value),
	query: z.string().optional(),
});

export type ProgressFilterSchemaType = z.infer<typeof ProgressFilterSchema>;
